import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IInTakeSurveyQuestionMeta } from '../../preferences/components/intake_survey/builders/ap_intake_survey_builder';
import { APIntakeSurveyNKHelper } from '../../preferences/components/preview_plan/helpers/intake_survey_nk_helper';
import { AdvisorHeaderDetailsQuery } from '../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';
import { StudentValueModel } from './../../global/components/student_value/model/student_value_model';
import { APUserModeAPIStrategy } from './../../global/strategies/user_mode_api_strategy';
import { TermPlanPreviewQuery } from './../../preferences/components/preview_plan/queries/preview_term_plan_query';
import { courseDetailState } from './../ap_course_details_routes';
import { PreventAccessToAdvisorAutoGeneratedPlanCommand } from './../re_route_strategies/prevent_access_to_advisor_auto_generated_plan_command';
import { COURSE_DETAIL_TEMPLATE } from './ap_advisor_course_detail_routes';

const AdvisorPreviewPlanCourseDetailState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@ap-advisor.preview_plan': {
      template: COURSE_DETAIL_TEMPLATE
    }
  }
};

export const AdvisorPreviewPlanRoutes = {
  'ap-advisor.preview_plan': <ng.ui.IState>{
    url: 'preview_plan/',
    template: '<ui-view></ui-view><ui-view name="right-panel-popout"></ui-view>',
    resolve: {
      clearCurrentResult: (clearTermPreviewPlanCommand: ICommand) => clearTermPreviewPlanCommand(),
      intakeSurveyPoll: (loadInTakeSurveyPollCommand: ICommand) => loadInTakeSurveyPollCommand(),
      intakeSurveyPollAnswers: (loadInTakeSurveyAnswerCommand: ICommand) => loadInTakeSurveyAnswerCommand(),
      termPreviewAPIParams: (
        intakeSurveyPoll: any,
        intakeSurveyPollAnswers: any,
        ngGetIntakeSurveyQuestionsQuery: IQuery,
        ngAPIntakeSurveyNKHelper: APIntakeSurveyNKHelper
      ) => {
        const questions: IInTakeSurveyQuestionMeta[] = ngGetIntakeSurveyQuestionsQuery.result.questions;
        const termCommitment = _4.find(questions, { nk: ngAPIntakeSurveyNKHelper.intakeSurveyTimeCommitmentNK })._answer
          .nk;
        const termPreference = _4.map(
          _4.find(questions, { nk: ngAPIntakeSurveyNKHelper.intakeSurveyTermPreferenceNK })._answer,
          'nk'
        );
        return {
          termCommitment,
          termPreference
        };
      }
    }
  },
  'ap-advisor.preview_plan.auto_generated': <ng.ui.IState>{
    url: 'auto_generated/',
    template: `
            <auto-generated-plan-header></auto-generated-plan-header>
            <preview-auto-generated-terms 
                l-kind l-justify="center"
                term-commitment="$resolve.termCommitmentAndPreference.termCommitment"
                term-preference="$resolve.termCommitmentAndPreference.termPreference" 
                terms="$resolve.terms">
            </preview-auto-generated-terms>`,
    data: {
      pageTitle: 'Autoloader'
    },
    resolve: {
      academicPlan: (loadAcademicPlanCommand: ICommand) => loadAcademicPlanCommand(),
      previewPlan: (termPreviewAPIParams: any, loadTermPreviewPlanCommand: ICommand) =>
        loadTermPreviewPlanCommand(termPreviewAPIParams.termCommitment, termPreviewAPIParams.termPreference),
      terms: (previewPlan: any, ngTermPlanPreviewQuery: TermPlanPreviewQuery, academicPlan: any) =>
        ngTermPlanPreviewQuery.result.terms,
      termCommitmentAndPreference: (termPreviewAPIParams: any) => termPreviewAPIParams,
      allowToProceed: (
        terms: TermPlanPreviewQuery['result']['terms'],
        preventAccessToAdvisorAutoGeneratedPlanCommand: PreventAccessToAdvisorAutoGeneratedPlanCommand
      ) => preventAccessToAdvisorAutoGeneratedPlanCommand(terms)
    }
  },
  'ap-advisor.preview_plan.auto_generated.course_details': {
    ...AdvisorPreviewPlanCourseDetailState
  },
  'ap-advisor.preview_plan.edit_preference': <ng.ui.IState>{
    url: 'edit_preference/',
    data: {
      pageTitle: 'Edit preference'
    },
    resolve: {
      clearTermPreviewPlan: (clearTermPreviewPlanCommand: ICommand) => clearTermPreviewPlanCommand(),
      academicPlan: (loadAcademicPlanForAdvisor: ICommand) => loadAcademicPlanForAdvisor(),
      questions: (termPreviewAPIParams: any, ngGetIntakeSurveyQuestionsQuery: any) =>
        ngGetIntakeSurveyQuestionsQuery.result.questions,
      showEditHeader: (academicPlan: any, ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery) =>
        ngAPAdvisorHeaderDetailsQuery.result.hasAdvisorPlan
    },
    template: `
            <advisor-edit-plan-header></advisor-edit-plan-header>
            <preview-terms-plan l-kind="hort" l-justify="center" questions="$resolve.questions"></preview-terms-plan>
        `
  },
  'ap-advisor.preview_plan.edit_preference.course_details': {
    ...AdvisorPreviewPlanCourseDetailState
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/ap_advisor_preview_plan_routes.ts